import type { CancelUnpaidOrderInput } from '@repo/api-contracts';
import { useInvalidateMyOrders } from '@/entities/order';
import { useInvalidateMyQuotes } from '@/entities/quote';
import { trpc } from '@/shared/api';

export interface UseCancelOrderResult {
  /** 실패하면 서버 오류를 그대로 던진다 — 문구·상태 충돌 재조회는 확인 대화상자가 맡는다. */
  readonly cancel: (input: CancelUnpaidOrderInput) => Promise<void>;
  readonly isPending: boolean;
}

/**
 * 결제 전 주문 취소(orders.cancel, 견적 설계 §7-9). 성공 응답(최신 상세)을 캐시에 넣고, 내 주문 목록과 복원된 견적
 * (ISSUED/EXPIRED)의 상세·목록을 다시 불러온다.
 */
export const useCancelOrder = (): UseCancelOrderResult => {
  const orders = useInvalidateMyOrders();
  const quotes = useInvalidateMyQuotes();
  const mutation = trpc.orders.cancel.useMutation();

  const cancel = async (input: CancelUnpaidOrderInput): Promise<void> => {
    const order = await mutation.mutateAsync(input);
    orders.putDetail(order);
    await Promise.all([orders.list(), quotes.detail(order.quoteRequestId), quotes.list()]);
  };

  return { cancel, isPending: mutation.isPending };
};
